<script>
  export let grayIcons;
</script>


<!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#2D536F;}
	.st1{fill:#6B6B6B;}
</style>
<g>
	<g>
		<path class="st0" d="M67.8,248.9c0-81.3,53-151.6,128.9-175v44.9l76.5-55.9l-76.5-56v39.7C105.8,70.8,41.6,153.2,41.6,248.9
			c0,94.3,63.5,177.5,154.4,202.2l6.9-25.3C123.4,404.2,67.8,331.4,67.8,248.9z"/>
		<path class="st0" d="M304,48.9l-6.9,25.3c79.5,21.6,135,94.3,135,176.8c0,81.3-53,151.6-128.9,175v-44.9l-76.5,56l76.5,55.9v-39.7
			c90.9-24.2,155.1-106.6,155.1-202.3C458.4,156.8,394.9,73.6,304,48.9z"/>
	</g>
	<path class="st0" d="M214.1,263.9c0,0,10.2-9.7,16.8-14.9c20.2,11.3,30.6,27.3,30.6,27.3s69.5-75.2,118-100.9l0,0
		C342.1,203.9,274,293.9,274,293.9l-20.8,9.9C253.2,303.8,236.3,271.3,214.1,263.9z"/>
	<g>
		<g>
			<path class="st1" d="M352.9,213.2c-11.4,13.5-22.1,27.2-31.4,39.6v70.8H178.2V218l71.8-53.5l64,47.8c5.5-5.2,11.3-10.5,17.5-15.7
				l-4.2-3.3v-58.7H303v40l-53-40.9L140.3,218v21.3h17.5v104.9h184.7V238.2h17.2v-19.8L352.9,213.2z"/>
		</g>
	</g>
</g>
</svg>



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/icons/ReverseCalculatorIcon.svelte